import { useSearchParams } from "react-router-dom";
import { useTryOpenMobileApp } from "../shared/useTryOpenMobileApp";
import Logo2 from "./../../assets/Logo2.png";
import {
  PageContainer,
  PageCard,
  PageHeader,
  PageBody,
  PageTitle,
  PageDescription,
  PageLogo,
  ActionButtons,
  ActionLink,
  ActionIcon,
  ActionLabel,
} from "../shared/authLayout";
import {
  APP_STORE_URL,
  PLAY_STORE_URL,
  APPLE_STORE_ICON,
  PLAY_STORE_ICON,
} from "../shared/constants";

export const AppInside = () => {
  const [searchParams] = useSearchParams();
  const original_survey_id = searchParams.get("original_survey_id") ?? undefined;
  const invitation_id = searchParams.get("invitation_id") ?? undefined;
  
  useTryOpenMobileApp({ original_survey_id, invitation_id });

  return (
    <PageContainer>
      <PageCard>
        <PageHeader>
          <PageLogo src={Logo2} alt="Inside Brasil" />
          <PageTitle>Aplicativo da Inside Brasil</PageTitle>
          <PageDescription>
            Agora, todo seu histórico na Inside é acessado apenas pelo nosso
            aplicativo. Baixe agora mesmo para ver suas pesquisas, os valores a
            receber e a possibilidade de ser remunerado por indicações para
            amigos.
          </PageDescription>
        </PageHeader>

        <PageBody>
          <ActionButtons>
            <ActionLink
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ActionIcon src={APPLE_STORE_ICON} alt="" aria-hidden />
              <ActionLabel>
                Disponível na
                <br />
                Apple Store
              </ActionLabel>
            </ActionLink>

            <ActionLink
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ActionIcon src={PLAY_STORE_ICON} alt="" aria-hidden />
              <ActionLabel>
                Disponível na
                <br />
                Google Play
              </ActionLabel>
            </ActionLink>
          </ActionButtons>
        </PageBody>
      </PageCard>
    </PageContainer>
  );
};
